import React from 'react'
import { Button } from '@chakra-ui/react'
import { Icon } from '.'
import { NavLink } from 'react-router-dom'

const NavButton = ({to, icon, label, colorScheme, ...rest }) => {
    return(
        <Button 
            as={NavLink} 
            to={to} 
            fontWeight="500" 
            leftIcon={<Icon mr="1.5" fontSize="20px" name={icon} color="currentColor" />}   
            _active={{ bg: "transparent" }} 
            bg="transparent" 
            _hover={{ bg: "rgba(0,0,0,0.15)",  textDecoration: 'none', _text:{textDecoration: 'none'}}} 
            borderLeft="3px solid transparent" 
            rounded="none" 
            color="rgba(255,255,255, 0.65)"
            fontSize="15px" 
            shadow="none" 
            w="100%"      
            h="48px"      
            justifyContent="flex-start" 
            textAlign="left" 
            className={`${"dash-nav "+ colorScheme || "" }`} 
            {...rest}
            > 
            {label} 
        </Button>
    )
}

export { NavButton }